import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import { ModalHelper } from '@/helpers/modal-helper-vfm';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferReporterSuccessModal',
  props: {
    email: { default: null },
    closeDelay: { default: 3000 }
  },
  setup(__props: any) {

const props = __props as { email: string | null, closeDelay: number };



onMounted(() => {
	setTimeout(() => {
		ModalHelper.close();
	}, props.closeDelay);
});

return { __sfc: true,props, BaseModal }
}

})